import { router } from '@inertiajs/react';
import { replaceQueryParams, getQueryParams } from '../utils/urlFunctions';
import { useMemo } from 'react';

const setQueryParams = (newParams) => {
  const newUrl = replaceQueryParams(window.location.href, newParams);
  router.visit(newUrl, {
    preserveScroll: true,
    preserveState: true,
  });
};

const useQueryParams = () => {
  return useMemo(() => {
    const queryParams = getQueryParams(window.location.href);

    return {
      queryParams,
      setQueryParams,
    };
  }, [location.href]);
};

export default useQueryParams;
